export default __webpack_public_path__ + "static/media/lg3.02a0f4e6.jpg";